import React, { useState, useRef, useEffect } from 'react';
import { 
  Copy, Reply, Star, Bookmark, Languages, SpellCheck, 
  Trash2, Forward, Pin, Download, Quote
} from 'lucide-react';
import { cn } from '../lib/utils';
import { toast } from 'sonner';

const ChatContextMenu = ({ x, y, message, onClose, onAction }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) onClose();
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const actions = [
    { id: 'reply', label: 'Responder', icon: Reply },
    { id: 'copy', label: 'Copiar', icon: Copy },
    { id: 'translate', label: 'Traducir', icon: Languages },
    { id: 'spellcheck', label: 'Corregir', icon: SpellCheck },
    { id: 'favorite', label: 'Favorito', icon: Star },
    { id: 'save', label: 'Guardar', icon: Bookmark },
    { id: 'quote', label: 'Citar', icon: Quote },
    { id: 'forward', label: 'Reenviar', icon: Forward },
    { id: 'pin', label: 'Fijar', icon: Pin },
    { id: 'download', label: 'Descargar', icon: Download },
  ];

  const handleAction = (actionId) => {
    if (actionId === 'copy') {
      navigator.clipboard.writeText(message?.content || '');
      toast.success('Copiado');
    } else if (onAction) {
      onAction(actionId, message);
    }
    onClose();
  };

  // Adjust position to stay in viewport
  const adjustedX = Math.min(x, window.innerWidth - 200);
  const adjustedY = Math.min(y, window.innerHeight - 350);

  return (
    <div ref={menuRef} data-testid="chat-context-menu"
      className="fixed z-[100] w-44 py-1 glass-bubble shadow-2xl animate-in fade-in zoom-in-95 duration-150"
      style={{ left: adjustedX, top: adjustedY }}>
      {actions.map(action => (
        <button key={action.id} data-testid={`ctx-${action.id}`}
          onClick={() => handleAction(action.id)}
          className="w-full flex items-center gap-2.5 px-3 py-2 text-xs hover:bg-white/10 transition-colors text-left">
          <action.icon className="w-3.5 h-3.5 text-muted-foreground" />
          <span>{action.label}</span>
        </button>
      ))}
    </div>
  );
};

export const useChatContextMenu = () => {
  const [menu, setMenu] = useState(null);

  const openMenu = (e, message) => {
    e.preventDefault();
    setMenu({ x: e.clientX, y: e.clientY, message });
  };

  const closeMenu = () => setMenu(null);

  const ContextMenuPortal = ({ onAction }) => {
    if (!menu) return null;
    return <ChatContextMenu x={menu.x} y={menu.y} message={menu.message} onClose={closeMenu} onAction={onAction} />;
  };

  return { openMenu, closeMenu, ContextMenuPortal };
};

export default ChatContextMenu;
